// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pw-0";